export function snake_case(string: string, delimiter = '_'): string {
	return string.replace(/[A-Z]+?/gum, char => `${delimiter}${char.toLowerCase()}`)
		.replace(new RegExp(`^${delimiter}`), '')
		.replace(/[^a-z0-9]/gim, delimiter);
}

export function camelCase(string: string): string {
	const snakeString = snake_case(string).toLowerCase();

	return snakeString.replace(/[^a-z0-9]+[a-z0-9]+?/mug, (match, index) => {
		return snakeString.substring(index + match.length - 1, index + match.length).toUpperCase();
	});
}

export function studlyCase(string: string): string {
	return camelCase(string).replace(/^.+?/ui, c => c.toUpperCase());
}
